import propTypes from 'prop-types';

export default {
  isModalOpen: propTypes.bool,
  isLinkExpired: propTypes.bool,
  setIsModalOpen: propTypes.func,
  setIsLinkExpired: propTypes.func,
  acceptModalHandler: propTypes.func,
};
